(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grand-sajawat"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__gsReady) return;
  window.__gsReady = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  /* Accepts 2026-11-15, 2026-11-15 23:59, 2026-11-15T23:59:00+05:30 … Safari-safe; no zone = India time */
  function parseEnd(v) {
    v = String(v || '').trim();
    if (!v) return NaN;
    var m = v.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?)?\s*(Z|[+-]\d{2}:?\d{2})?$/i);
    if (m) {
      var tz = m[7] || '+05:30';
      if (/^[+-]\d{4}$/.test(tz)) tz = tz.slice(0, 3) + ':' + tz.slice(3);
      var iso = m[1] + '-' + pad(+m[2]) + '-' + pad(+m[3]) + 'T' + (m[4] ? pad(+m[4]) + ':' + m[5] + ':' + (m[6] || '00') : '23:59:59') + (tz.toUpperCase() === 'Z' ? 'Z' : tz);
      return Date.parse(iso);
    }
    return Date.parse(v);
  }

  function init(root) {
    if (!root || root.__gs) return;
    root.__gs = true;
    var toastEl = root.querySelector('[data-gstoast]');
    var toastTimer;

    function toast(msg, isErr, plain) {
      if (!toastEl) return;
      toastEl.querySelector('[data-gsmsg]').textContent = msg;
      toastEl.classList.toggle('is-err', !!isErr);
      toastEl.classList.toggle('is-plain', !!plain);
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, isErr ? 4000 : 6000);
    }

    /* ---------- campaign tracking (no extra scripts; uses whatever analytics is already on the site) ---------- */
    var camp = root.dataset.track;
    function track(name, data) {
      if (!camp) return;
      var d = { campaign: camp, page_path: location.pathname };
      for (var k in data) d[k] = data[k];
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, d)); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, d); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', name, d); } catch (e) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
    }
    function where(el) {
      var blk = el && el.closest('.gs-blk');
      return blk ? { block: blk.dataset.gst, block_position: +blk.dataset.gsi } : {};
    }
    function tagOrder(src) {
      if (!camp || root.dataset.tagorder !== 'true') return;
      try { if (sessionStorage.getItem('gs-tagged') === camp) return; } catch (e) {}
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Landing page': camp, 'Landing block': src || '' } }) })
        .then(function () { try { sessionStorage.setItem('gs-tagged', camp); } catch (e) {} }).catch(function () {});
    }
    if (camp) {
      try { if (typeof window.clarity === 'function') window.clarity('set', 'campaign_page', camp); } catch (e) {}
      var utm = {}; location.search.replace(/[?&](utm_[a-z]+|gclid|fbclid)=([^&]*)/g, function (_, k, v) { utm[k] = decodeURIComponent(v).slice(0, 80); });
      track('gs_page_view', utm);
      if ('IntersectionObserver' in window) {
        var seen = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting) return;
            seen.unobserve(en.target);
            track('gs_section_view', { block: en.target.dataset.gst, block_position: +en.target.dataset.gsi });
          });
        }, { threshold: 0.35 });
        root.querySelectorAll('.gs-blk[data-gst]').forEach(function (el) { seen.observe(el); });
      }
      var marks = [25, 50, 75, 100], sent = {};
      var onScroll = function () {
        var r = root.getBoundingClientRect(), h = r.height - window.innerHeight;
        var pct = h > 0 ? Math.min(100, Math.max(0, (-r.top / h) * 100)) : 100;
        marks.forEach(function (m) { if (pct >= m - 1 && !sent[m]) { sent[m] = 1; track('gs_scroll', { percent: m }); } });
      };
      window.addEventListener('scroll', function () { if (!onScroll.t) { onScroll.t = setTimeout(function () { onScroll.t = 0; onScroll(); }, 400); } }, { passive: true });
    }

    /* ---------- countdown ---------- */
    var end = parseEnd(root.dataset.end);
    if (!isNaN(end)) root.classList.add('has-end');
    var urgentMs = (parseFloat(root.dataset.urgent) || 0) * 86400000;
    if (!isNaN(end)) {
      var tick = function () {
        if (document.hidden) return;
        var left = Math.max(0, end - Date.now()), s = Math.floor(left / 1000);
        root.classList.toggle('is-near', left <= urgentMs);
        var u = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        root.querySelectorAll('[data-gsu]').forEach(function (el) { var v = pad(u[el.dataset.gsu]); if (el.textContent !== v) { el.textContent = v; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); } });
        root.querySelectorAll('[data-gscd]').forEach(function (el) {
          el.textContent = (u.d ? u.d + 'd ' : '') + pad(u.h) + 'h ' + pad(u.m) + 'm ' + pad(u.s) + 's';
        });
        if (left <= urgentMs) root.querySelectorAll('[data-gscds]').forEach(function (el) {
          el.textContent = u.d ? u.d + 'd ' + pad(u.h) + 'h' : pad(u.h) + 'h ' + pad(u.m) + 'm ' + pad(u.s) + 's';
        });
        if (left <= 0) { root.classList.add('is-ended'); clearInterval(timer); }
      };
      var timer = setInterval(tick, 1000);
      tick();
    }

    /* ---------- delivery promise & flash-deal rows ---------- */
    var design = root.dataset.design === '1';
    var dlEnd = parseEnd(root.dataset.dl);
    var deals = [].slice.call(root.querySelectorAll('[data-gsdeal-end]')).map(function (el) {
      return { el: el, start: parseEnd(el.dataset.gsdealStart), end: parseEnd(el.dataset.gsdealEnd), out: el.querySelector('[data-gsdealcd]') };
    });
    function dealTick() {
      var now = Date.now();
      root.classList.toggle('dl-over', !isNaN(dlEnd) && now > dlEnd);
      deals.forEach(function (d) {
        var live = !isNaN(d.end) && now < d.end && (isNaN(d.start) || now >= d.start);
        d.el.classList.toggle('is-live', live || design);
        if (d.out) {
          var left = Math.max(0, (isNaN(d.end) ? 0 : d.end) - now), s = Math.floor(left / 1000);
          var dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
          d.out.textContent = (dd ? dd + 'd ' : '') + pad(hh) + ':' + pad(mm) + ':' + pad(ss);
        }
      });
    }
    dealTick();
    if (deals.length || !isNaN(dlEnd)) setInterval(dealTick, 1000);

    /* ---------- consecutive "Complete the look" blocks become one slider ---------- */
    if (root.dataset.design !== '1') {
      var groups = [], cur = [];
      root.querySelectorAll('.gs-blk[data-gst="bundle"]').forEach(function (el) {
        if (cur.length && cur[cur.length - 1].nextElementSibling === el) cur.push(el);
        else { if (cur.length) groups.push(cur); cur = [el]; }
      });
      if (cur.length) groups.push(cur);
      groups.forEach(function (g) {
        if (g.length < 2) return;
        var wrap = document.createElement('div'), trk = document.createElement('div'), nav = document.createElement('div');
        wrap.className = 'gs-bslide'; trk.className = 'gs-bslide__track'; nav.className = 'gs-bslide__nav';
        g[0].parentNode.insertBefore(wrap, g[0]);
        wrap.appendChild(trk); wrap.appendChild(nav);
        g.forEach(function (el) { el.classList.add('gs-bslide__item'); trk.appendChild(el); });
        nav.innerHTML = '<button type="button" class="gs-bslide__arr" data-bs="-1" aria-label="Previous look">&larr;</button><span class="gs-bslide__dots">' +
          g.map(function (_, i) { return '<button type="button" class="gs-bslide__dot" data-bsi="' + i + '" aria-label="Look ' + (i + 1) + '"></button>'; }).join('') +
          '</span><button type="button" class="gs-bslide__arr" data-bs="1" aria-label="Next look">&rarr;</button>';
        var dots = nav.querySelectorAll('.gs-bslide__dot');
        var idx = function () { return Math.round(trk.scrollLeft / Math.max(1, trk.clientWidth)); };
        var mark = function () { var k = idx(); dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); }); };
        var go = function (k) { k = Math.max(0, Math.min(g.length - 1, k)); trk.scrollTo({ left: k * trk.clientWidth, behavior: 'smooth' }); };
        nav.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          if (b.dataset.bs) go(idx() + +b.dataset.bs); else go(+b.dataset.bsi);
          track('gs_look_slide', {});
        });
        var t; trk.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 80); }, { passive: true });
        mark();
      });
    }

    /* ---------- cart ---------- */
    function money(paise, cur) {
      try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur || 'INR', maximumFractionDigits: 0 }).format(paise / 100); }
      catch (e) { return '₹' + Math.round(paise / 100); }
    }

    function refreshCart() {
      var cartUrl = (root.dataset.cartUrl || '/cart') + '.js';
      return fetch(cartUrl, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count],.cart-count,.cart-count-bubble span,#CartCount,.header__cart-count,cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          ['cart:refresh', 'cart:updated', 'cart:change', 'theme:cart:reload'].forEach(function (n) {
            document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } }));
          });
          return cart;
        });
    }

    function add(items, btn) {
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch(root.dataset.addUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          var src = where(btn), card = btn.closest('.gs-card');
          var val = 0; items.forEach(function (it) { var c = root.querySelector('[data-gsid="' + it.id + '"]'); val += c && c.closest('.gs-card') ? +c.closest('.gs-card').dataset.gspp || 0 : 0; });
          track(items.length > 1 ? 'gs_bundle_add' : 'gs_add_to_cart', Object.assign({ items: items.length, product_id: card ? card.dataset.gspid : '', product: card ? card.dataset.gspt : '', value: card ? (+card.dataset.gspp || 0) / 100 : val / 100, currency: 'INR' }, src));
          tagOrder(src.block);
          var after = root.dataset.after;
          if (after === 'cart' || after === 'checkout') { location.href = root.dataset.cartUrl || '/cart'; return; }
          btn.textContent = 'Added ✓'; btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
          return refreshCart().then(function (cart) {
            toast('Added to cart · ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' · ' + money(cart.total_price, cart.currency));
          }, function () { toast('Added to cart'); });
        })
        .catch(function (err) {
          toast((err && (err.description || err.message)) || 'Sorry, this could not be added. Please try again.', true);
        })
        .then(function () {
          setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1200);
        });
    }

    function copy(code, btn) {
      var done = function () {
        var old = btn.textContent;
        btn.textContent = 'Copied ✓';
        setTimeout(function () { btn.textContent = old; }, 2000);
        toast(code + ' copied. Paste it in the coupon box at checkout.', false, true);
      };
      if (root.dataset.apply === 'true') {
        fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent((root.dataset.cartUrl || '/cart') + '.js'), { credentials: 'same-origin' }).catch(function () {});
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else fallback();
      function fallback() {
        var t = document.createElement('textarea');
        t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(t);
        done();
      }
    }

    /* ---------- hidden tab panes are parked in <template> until first opened ---------- */
    function inflate(p) {
      var tpl = p && p.querySelector(':scope > template[data-gstpl]');
      if (!tpl) return;
      p.appendChild(tpl.content); tpl.remove();
      p.querySelectorAll('.gs-track, .gs-grid--swipe').forEach(function (tr) { tr.dispatchEvent(new Event('scroll')); });
    }
    root.addEventListener('pointerover', function (e) {
      var t = e.target.closest && e.target.closest('[data-gstab]');
      if (!t) return;
      var g = t.closest('[data-gstabs]');
      if (g) inflate(g.querySelector('[data-gspane="' + t.dataset.gstab + '"]'));
    }, { passive: true });

    /* ---------- pause festive animations that are off screen ---------- */
    if ('IntersectionObserver' in window) {
      var vis = new IntersectionObserver(function (es) { es.forEach(function (en) { en.target.classList.toggle('is-off', !en.isIntersecting); }); }, { rootMargin: '150px 0px' });
      root.querySelectorAll('.gs-blk').forEach(function (el) { vis.observe(el); });
    }

    /* ---------- start loading images ~2 screens before they are reached (iPhone Safari waits too long otherwise) ---------- */
    var startPre = function () {
      if (!('IntersectionObserver' in window)) return;
      var pre = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          pre.unobserve(en.target);
          en.target.querySelectorAll('img[loading="lazy"]').forEach(function (im) { if (!im.closest('template')) im.loading = 'eager'; });
        });
      }, { rootMargin: '1600px 0px' });
      root.querySelectorAll('.gs-blk').forEach(function (el) { pre.observe(el); });
    };
    if (document.readyState === 'complete') startPre(); else window.addEventListener('load', startPre);
    /* ---------- thin progress bar under swipe rows on phones ---------- */
    root.querySelectorAll('.gs-track, .gs-grid--swipe, .gs-rooms').forEach(function (tr) {
      if (tr.parentNode.querySelector(':scope > .gs-prog')) return;
      var bar = document.createElement('div'); bar.className = 'gs-prog'; bar.innerHTML = '<i></i>';
      tr.insertAdjacentElement('afterend', bar);
      var fill = bar.firstChild;
      var upd = function () { var max = tr.scrollWidth - tr.clientWidth; bar.hidden = max < 4; var vis = tr.clientWidth / Math.max(1, tr.scrollWidth); fill.style.width = (vis * 100) + '%'; fill.style.transform = 'translateX(' + (max > 0 ? (tr.scrollLeft / max) * (1 / vis - 1) * 100 : 0) + '%)'; };
      tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });

    /* ---------- hide arrows when a row can't scroll ---------- */
    function arrows() {
      root.querySelectorAll('.gs-tw').forEach(function (w) {
        var tr = w.querySelector('.gs-track');
        w.classList.toggle('no-arr', !tr || tr.children.length === 0 || tr.scrollWidth <= tr.clientWidth + 4);
      });
    }
    arrows(); window.addEventListener('resize', arrows); window.addEventListener('load', arrows);

    /* ---------- sliding pill for budget tabs ---------- */
    function movePill(g) {
      var bar = g.querySelector('.gs-tabs'), pill = g.querySelector('.gs-tabs__pill'), on = g.querySelector('.gs-tab[aria-pressed="true"]');
      if (!bar || !pill || !on) return;
      pill.style.width = on.offsetWidth + 'px';
      pill.style.transform = 'translateX(' + (on.offsetLeft - bar.scrollLeft * 0) + 'px)';
      bar.classList.add('has-pill');
    }
    root.querySelectorAll('[data-gstabs]').forEach(function (g) { if (g.querySelector('.gs-tabs__pill')) { movePill(g); window.addEventListener('resize', function () { movePill(g); }); } });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { root.querySelectorAll('[data-gstabs]').forEach(movePill); });

    /* ---------- clicks ---------- */
    root.addEventListener('click', function (e) {
      var el;
      if (camp) {
        var link = e.target.closest('a[href]');
        if (link && link.hasAttribute('data-gswa')) track('gs_whatsapp_click', where(link));
        else if (link && !link.hasAttribute('data-gsmore')) {
          var cd = link.closest('.gs-card');
          if (cd) track('gs_product_click', Object.assign({ product_id: cd.dataset.gspid, product: cd.dataset.gspt, position: [].indexOf.call(cd.parentNode.children, cd) + 1 }, where(cd)));
          else track('gs_link_click', Object.assign({ link: link.getAttribute('href').slice(0, 120), text: (link.textContent || '').trim().slice(0, 60) }, where(link)));
        }
        var tb = e.target.closest('[data-gstab]');
        if (tb) track('gs_tab_click', Object.assign({ tab: (tb.querySelector('.gs-pc__n') || tb).textContent.trim().slice(0, 40) }, where(tb)));
        var cp = e.target.closest('[data-gscopy]');
        if (cp) track('gs_coupon_copy', Object.assign({ code: cp.dataset.gscopy }, where(cp)));
      }
      var rb = e.target.closest('.gs-btn, .gs-tab, .gs-code button');
      if (rb && root.classList.contains('gs--fx')) {
        var r = rb.getBoundingClientRect(), s = document.createElement('span');
        s.className = 'gs-ripple'; s.style.left = (e.clientX - r.left) + 'px'; s.style.top = (e.clientY - r.top) + 'px';
        rb.appendChild(s); setTimeout(function () { s.remove(); }, 650);
      }
      if ((el = e.target.closest('[data-gsadd]'))) {
        var sel = el.parentNode.querySelector('[data-gsvar]');
        var id = sel ? sel.value : el.dataset.gsid;
        if (id) add([{ id: +id, quantity: 1 }], el);
        return;
      }
      if ((el = e.target.closest('[data-gsbundle]'))) {
        var ids = el.dataset.gsbundle.split(',').filter(Boolean);
        if (ids.length) add(ids.map(function (x) { return { id: +x, quantity: 1 }; }), el);
        return;
      }
      if ((el = e.target.closest('[data-gscopy]'))) { copy(el.dataset.gscopy, el); return; }
      if ((el = e.target.closest('[data-gstab]'))) {
        var g = el.closest('[data-gstabs]');
        g.querySelectorAll('[data-gstab]').forEach(function (t) {
          var on = t === el;
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
          t.classList.toggle('is-on', on);
        });
        g.querySelectorAll('[data-gspane]').forEach(function (p) { var on2 = p.dataset.gspane === el.dataset.gstab; if (on2) inflate(p); p.hidden = !on2; });
        movePill(g); arrows();
        if (el.classList.contains('gs-pc')) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
        var all = g.querySelector('[data-gsall]');
        if (all) { all.hidden = !el.dataset.gshref; if (el.dataset.gshref) all.setAttribute('href', el.dataset.gshref); }
        return;
      }
      if ((el = e.target.closest('[data-gsdir]'))) {
        var tr = el.parentNode.querySelector('.gs-track');
        tr.scrollBy({ left: +el.dataset.gsdir * tr.clientWidth * 0.8, behavior: 'smooth' });
        return;
      }
      if ((el = e.target.closest('[data-gsmore]'))) {
        e.preventDefault();
        var url = el.getAttribute('href');
        el.textContent = 'Loading…';
        fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + root.dataset.section)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grid = root.querySelector('[data-full-grid]');
            var next = doc.querySelector('[data-full-grid]');
            if (grid && next) while (next.firstChild) grid.appendChild(next.firstChild);
            var wrap = root.querySelector('[data-gsmorewrap]');
            var nwrap = doc.querySelector('[data-gsmorewrap]');
            if (wrap) wrap.innerHTML = nwrap ? nwrap.innerHTML : '';
          })
          .catch(function () { location.href = url; });
        return;
      }
      if ((el = e.target.closest('[data-gsx]'))) {
        el.closest('[data-gssticky]').remove();
        try { sessionStorage.setItem('gs-sticky-x', '1'); } catch (err) {}
      }
    });

    root.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-gstab][role="button"]')) { e.preventDefault(); e.target.click(); }
    });

    /* ---------- sticky bar ---------- */
    var sticky = root.querySelector('[data-gssticky]');
    if (sticky) {
      var closed = false;
      try { closed = sessionStorage.getItem('gs-sticky-x') === '1'; } catch (err) {}
      if (closed) sticky.remove();
      else {
        var ticking = false;
        var check = function () {
          ticking = false;
          var r = root.getBoundingClientRect();
          sticky.classList.toggle('is-on', r.top < -400 && r.bottom > window.innerHeight);
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        check();
      }
    }
  }

  function boot() { document.querySelectorAll('[data-gs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-gs]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-bundles"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__gsbReady) return;
  window.__gsbReady = true;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function init(root) {
    if (!root || root.__gsb) return;
    root.__gsb = true;
    var grid = root.querySelector('[data-gsb-grid]');
    var toastEl = root.querySelector('[data-gsb-toast]'), tt;
    function toast(msg, err) {
      if (!toastEl) return;
      toastEl.querySelector('[data-msg]').textContent = msg;
      toastEl.classList.toggle('is-err', !!err);
      toastEl.classList.add('is-on');
      clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('is-on'); }, err ? 4000 : 6500);
    }
    function cards() { return Array.prototype.slice.call(grid.querySelectorAll('[data-gsb-card]')); }

    /* ---------- countdowns + hide expired bundles ---------- */
    function tick() {
      var now = Date.now();
      cards().forEach(function (c) {
        var end = Date.parse(c.dataset.end || '');
        if (isNaN(end)) return;
        var left = end - now;
        if (left <= 0) { c.remove(); layout(); return; }
        var el = c.querySelector('[data-gsb-cd]'); if (!el) return;
        var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
        el.textContent = d ? d + 'd ' + pad(h) + 'h' : pad(h) + 'h ' + pad(m) + 'm ' + pad(s % 60) + 's';
      });
    }

    /* ---------- limit, view all, chips, counter ---------- */
    var limit = +root.dataset.limit || 9, expanded = !!root.dataset.source, filter = '';
    function layout() {
      var list = cards(), shown = 0, matching = 0;
      list.forEach(function (c) {
        var match = !filter || c.dataset.cat === filter;
        c.classList.toggle('is-filtered', !match);
        if (!match) { c.classList.remove('is-extra'); return; }
        matching++;
        var extra = !expanded && !filter && matching > limit;
        c.classList.toggle('is-extra', extra);
        if (!extra) shown++;
      });
      var more = root.querySelector('[data-gsb-morewrap]'), link = root.querySelector('[data-gsb-alllink]');
      var hasMore = !expanded && !filter && matching > limit;
      if (more) { more.hidden = !(hasMore && root.dataset.mode === 'expand'); more.querySelector('button').textContent = (more.dataset.label || (more.dataset.label = more.querySelector('button').textContent)) + ' (' + matching + ')'; }
      if (link) link.hidden = !(hasMore && root.dataset.mode === 'link');
    }
    function buildChips() {
      var box = root.querySelector('[data-gsb-chips]'); if (!box || root.dataset.chips !== 'true') return;
      var cats = []; cards().forEach(function (c) { var k = c.dataset.cat; if (k && cats.indexOf(k) < 0) cats.push(k); });
      if (cats.length < 2) { box.hidden = true; return; }
      box.innerHTML = ['<button type="button" class="gsb-chipbtn" data-gsb-chip="" aria-pressed="true">All</button>'].concat(cats.map(function (k) {
        return '<button type="button" class="gsb-chipbtn" data-gsb-chip="' + k.replace(/"/g, '&quot;') + '" aria-pressed="false">' + k.replace(/</g, '&lt;') + '</button>';
      })).join('');
      box.hidden = false;
    }
    function sortCards() {
      if (root.dataset.sort !== 'saving') return;
      cards().sort(function (a, b) { return (+b.dataset.save || 0) - (+a.dataset.save || 0); }).forEach(function (c) { grid.appendChild(c); });
    }
    function counter() {
      var n = root.querySelector('.gsb-count');
      if (!n) { n = document.createElement('p'); n.className = 'gsb-count'; grid.after(n); }
      var vis = cards().filter(function (c) { return !c.classList.contains('is-filtered'); });
      var w = vis[0] ? vis[0].offsetWidth + 12 : 1;
      n.textContent = vis.length > 1 ? (Math.min(vis.length, Math.round(grid.scrollLeft / w) + 1)) + ' / ' + vis.length : '';
    }
    grid.addEventListener('scroll', function () { requestAnimationFrame(counter); }, { passive: true });

    /* ---------- add to cart ---------- */
    function add(btn) {
      var ids = (btn.dataset.ids || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
      fetch(root.dataset.addUrl || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids.map(function (x) { return { id: +x, quantity: 1 }; }) }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          if (root.dataset.after === 'checkout') { location.href = '/checkout'; return; }
          if (root.dataset.after === 'cart') { location.href = root.dataset.cartUrl || '/cart'; return; }
          btn.textContent = 'Added ✓'; btn.classList.add('is-added');
          ['cart:refresh', 'cart:updated', 'theme:cart:reload'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });
          return fetch((root.dataset.cartUrl || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('[data-cart-count],.cart-count,.cart-count-bubble span,#CartCount,.header__cart-count').forEach(function (el) { el.textContent = c.item_count; });
            toast('Set added' + (btn.dataset.hasSaving ? ' · you saved ' + btn.dataset.saving : '') + ' · ' + c.item_count + (c.item_count === 1 ? ' item' : ' items') + ' in cart');
          }, function () { toast('Set added to cart'); });
        })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, this set could not be added. Please try again.', true); })
        .then(function () { setTimeout(function () { btn.disabled = false; btn.innerHTML = label; btn.classList.remove('is-added'); }, 1600); });
    }

    /* ---------- piece options: update what gets added + live totals ---------- */
    function money(p) { try { return '₹ ' + Math.round(p / 100).toLocaleString('en-IN'); } catch (e) { return '₹ ' + Math.round(p / 100); } }
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('select[data-gsb-var]'); if (!sel) return;
      var card = sel.closest('[data-gsb-card]'), idx = +sel.dataset.for, opt = sel.options[sel.selectedIndex];
      var thumbs = card.querySelectorAll('[data-gsb-thumb]'), th = thumbs[idx];
      if (th) { th.dataset.vid = opt.value; th.dataset.cents = opt.dataset.cents; th.dataset.price = opt.dataset.price; th.querySelector('.gsb-thumb__p').textContent = opt.dataset.price; }
      var ids = [], total = 0;
      thumbs.forEach(function (t) { ids.push(t.dataset.vid); total += +t.dataset.cents || 0; });
      var btn = card.querySelector('[data-gsb-add]'); btn.dataset.ids = ids.join(',');
      var type = card.dataset.dtype, val = +card.dataset.dval || 0, save = 0;
      if (type === 'percent' && val > 0) save = Math.floor(total * val / 100);
      else if (type === 'fixed' && val > 0) save = Math.min(total, val * 100);
      var f = card.querySelector('[data-gsb-final]'); if (f) f.textContent = money(total - save);
      var t0 = card.querySelector('[data-gsb-total]'); if (t0) t0.textContent = money(total);
      var sv = card.querySelector('[data-gsb-saving]'); if (sv) sv.textContent = money(save);
      var bp = card.querySelector('[data-gsb-btnprice]'); if (bp) bp.textContent = money(total - save);
      if (type === 'fixed') { var bd = card.querySelector('[data-gsb-badge]'); if (bd) bd.textContent = 'Save ' + money(save); }
      btn.dataset.saving = money(save);
    });

    /* ---------- sheet ---------- */
    var sheet = root.querySelector('[data-gsb-sheet]');
    function openSheet(t) {
      sheet.querySelector('[data-s-img]').src = t.dataset.img || '';
      sheet.querySelector('[data-s-title]').textContent = t.dataset.title;
      sheet.querySelector('[data-s-price]').textContent = t.dataset.price;
      sheet.querySelector('[data-s-url]').href = t.dataset.url;
      sheet.hidden = false; sheet.querySelector('.gsb-sheet__x').focus();
    }
    function closeSheet() { sheet.hidden = true; }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet(); });

    root.addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('[data-gsb-add]'))) { add(el); return; }
      if ((el = e.target.closest('[data-gsb-thumb]'))) { openSheet(el); return; }
      if ((el = e.target.closest('[data-gsb-close]'))) { closeSheet(); return; }
      if ((el = e.target.closest('[data-gsb-more]'))) {
        expanded = true; layout();
        cards().forEach(function (c) { if (!c.classList.contains('is-new')) c.classList.add('is-new'); });
        return;
      }
      if ((el = e.target.closest('[data-gsb-chip]'))) {
        filter = el.dataset.gsbChip;
        root.querySelectorAll('[data-gsb-chip]').forEach(function (c) { c.setAttribute('aria-pressed', c === el ? 'true' : 'false'); });
        layout(); grid.scrollLeft = 0; counter();
      }
    });

    /* ---------- reveal ---------- */
    function reveal() {
      if (!root.classList.contains('gsb--fx') || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.Shopify && window.Shopify.designMode) return;
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      cards().forEach(function (c, i) {
        if (c.getBoundingClientRect().top < window.innerHeight) return;
        c.classList.add('gsb-rv'); c.style.setProperty('--i', i % 3); io.observe(c);
      });
    }

    function start() { sortCards(); buildChips(); layout(); tick(); counter(); reveal(); setInterval(tick, 1000); }

    /* ---------- landing-page mode ---------- */
    var src = root.dataset.source;
    if (src) {
      grid.insertAdjacentHTML('beforeend', '<p class="gsb-loading">Loading bundles…</p>');
      fetch(src, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var found = doc.querySelectorAll('[data-gsb] [data-gsb-card]');
        var ld = grid.querySelector('.gsb-loading'); if (ld) ld.remove();
        found.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        if (!found.length) grid.insertAdjacentHTML('beforeend', '<p class="gsb-loading">No bundles found yet.</p>');
        start();
      }).catch(function () { var ld = grid.querySelector('.gsb-loading'); if (ld) ld.textContent = 'Could not load bundles right now.'; });
    } else start();
  }

  function boot() { document.querySelectorAll('[data-gsb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-gsb]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikiru-gift-rewards"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__igr)return;window.__igr=1;document.addEventListener('click',function(e){var b=e.target.closest('[data-igrcopy]');if(!b)return;var c=b.dataset.igrcopy,d=function(){var o=b.lastChild.textContent;b.lastChild.textContent='Copied ✓';setTimeout(function(){b.lastChild.textContent=o},1800)};if(navigator.clipboard&&window.isSecureContext)navigator.clipboard.writeText(c).then(d,d);else{var t=document.createElement('textarea');t.value=c;document.body.appendChild(t);t.select();try{document.execCommand('copy')}catch(x){}t.remove();d()}});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikiru-shop-by-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(p) { try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(Math.floor(p / 100)); } catch (e) { return '₹' + Math.floor(p / 100); } }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function init(root) {
    if (!root || root.__sbv) return; root.__sbv = true;
    var row = root.querySelector('[data-sbv-row]'), tiles = [].slice.call(root.querySelectorAll('[data-sbv-tile]'));
    var modal = root.querySelector('[data-sbv-modal]'), big = root.querySelector('[data-sbv-big]'), shop = root.querySelector('[data-sbv-shop]');
    var camp = root.dataset.track, cur = 0, state = { p: 0 };
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData);
    function track(n, d) {
      if (!camp) return; d = Object.assign({ campaign: camp, page_path: location.pathname, block: 'shop_by_video' }, d || {});
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: n }, d)); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', n, d); } catch (e) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (e) {}
    }
    /* row: load + play only while on screen */
    if (!calm && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var v = en.target.querySelector('video');
          if (en.isIntersecting && modal.hidden) { v.muted = true; if (!v.getAttribute('src')) v.src = en.target.dataset.sm; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: 0.2 });
      tiles.forEach(function (t) { io.observe(t); });
    }
    function arrows() { root.querySelector('.sbv__tw').classList.toggle('no-arr', !row || row.scrollWidth <= row.clientWidth + 4); }
    arrows(); window.addEventListener('resize', arrows);

    var toastEl = root.querySelector('[data-sbv-toast]'), tt;
    function toast(m, err) { toastEl.querySelector('[data-sbv-msg]').textContent = m; toastEl.classList.toggle('is-err', !!err); toastEl.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('is-on'); }, err ? 4000 : 5000); }
    function data(n) { var el = root.querySelector('[data-sbv-data="' + n + '"]'); try { return JSON.parse(el.textContent); } catch (e) { return { products: [] }; } }

    function renderShop() {
      var d = data(cur), ps = d.products || [];
      if (!ps.length) { shop.innerHTML = '<div class="sbv-s"><p class="sbv-s__cap">' + esc(d.caption || '') + '</p></div>'; return; }
      var p = ps[state.p] || ps[0], imgs = (p.images || []).filter(Boolean);
      var v = p.variants.filter(function (x) { return x.id === state.v; })[0] || p.variants.filter(function (x) { return x.id === p.first; })[0] || p.variants[0];
      state.v = v.id;
      var save = v.cmp > v.price ? v.cmp - v.price : 0;
      var h = '<div class="sbv-s"><div class="sbv-s__body">';
      h += '<div class="sbv-s__imgs">' + (imgs.length ? imgs : [p.thumb]).map(function (u) { return '<img src="' + esc(u) + '" alt="" loading="lazy">'; }).join('') + '</div>';
      h += '<a class="sbv-s__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>';
      h += '<div class="sbv-s__pr"><b>' + money(v.price) + '</b>' + (save ? '<s>' + money(v.cmp) + '</s><span>Save ' + money(save) + '</span>' : '') + '</div>';
      if (p.variants.length > 1) h += '<label class="sbv-s__vl">Option<select data-sbv-var>' + p.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.ok ? '' : ' disabled') + '>' + esc(x.title) + (x.ok ? '' : ' (sold out)') + '</option>'; }).join('') + '</select></label>';
      if (ps.length > 1) h += '<div class="sbv-s__in"><span>In this video</span><div>' + ps.map(function (x, i) { return '<button type="button" data-sbv-pick="' + i + '" class="' + (i === state.p ? 'is-on' : '') + '" aria-label="' + esc(x.title) + '"><img src="' + esc(x.thumb) + '" alt=""></button>'; }).join('') + '</div></div>';
      h += '</div><div class="sbv-s__act"><a class="sbv-btn sbv-btn--ghost" href="' + esc(p.url) + '">View product</a><button type="button" class="sbv-btn" data-sbv-add' + (v.ok ? '' : ' disabled') + '>' + (v.ok ? 'Add to cart' : 'Sold out') + '</button></div></div>';
      shop.innerHTML = h;
    }
    function open(n) {
      cur = n; state = { p: 0 };
      tiles.forEach(function (t) { t.querySelector('video').pause(); });
      var t = root.querySelector('[data-sbv-tile="' + n + '"]');
      big.src = t.dataset.lg || t.dataset.sm; big.poster = t.querySelector('video').poster;
      var pr = big.play(); if (pr && pr.catch) pr.catch(function () {});
      renderShop();
      modal.hidden = false; document.documentElement.classList.add('sbv-lock');
      root.querySelector('[data-sbv-step="-1"]').hidden = n <= 1; root.querySelector('[data-sbv-step="1"]').hidden = n >= tiles.length;
      track('gs_video_open', { video: n });
    }
    function close() {
      modal.hidden = true; big.pause(); big.removeAttribute('src'); big.load();
      document.documentElement.classList.remove('sbv-lock');
      tiles.forEach(function (t) { var r = t.getBoundingClientRect(); if (!calm && r.right > 0 && r.left < innerWidth && r.bottom > 0 && r.top < innerHeight) { var v = t.querySelector('video'); if (v.getAttribute('src')) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } } });
    }
    function refreshCart() {
      return fetch((root.dataset.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count],.cart-count,.cart-count-bubble span,#CartCount,.header__cart-count,cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        ['cart:refresh', 'cart:updated', 'cart:change', 'theme:cart:reload'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } })); document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } })); });
        return cart;
      });
    }
    function add(btn) {
      var d = data(cur), p = d.products[state.p]; if (!p) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(root.dataset.addUrl || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: state.v, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          btn.textContent = 'Added ✓';
          track('gs_add_to_cart', { product_id: String(p.id), product: p.title, source: 'video', video: cur });
          if (camp) { try { if (sessionStorage.getItem('gs-tagged') !== camp) fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Landing page': camp, 'Landing block': 'shop_by_video' } }) }).then(function () { sessionStorage.setItem('gs-tagged', camp); }); } catch (e) {} }
          return refreshCart().then(function (c) { toast('Added to cart · ' + c.item_count + (c.item_count === 1 ? ' item' : ' items')); });
        })
        .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add. Please try again.', true); })
        .then(function () { setTimeout(function () { btn.disabled = false; btn.textContent = 'Add to cart'; }, 1400); });
    }
    root.addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('[data-sbv-tile]'))) { open(+el.dataset.sbvTile); return; }
      if ((el = e.target.closest('[data-sbv-dir]'))) { row.scrollBy({ left: +el.dataset.sbvDir * row.clientWidth * 0.8, behavior: 'smooth' }); return; }
      if (e.target.closest('[data-sbv-close]')) { close(); return; }
      if ((el = e.target.closest('[data-sbv-step]'))) { var nx = cur + +el.dataset.sbvStep; if (nx >= 1 && nx <= tiles.length) open(nx); return; }
      if ((el = e.target.closest('[data-sbv-sound]'))) { big.muted = !big.muted; el.classList.toggle('is-on', !big.muted); el.setAttribute('aria-label', big.muted ? 'Turn sound on' : 'Turn sound off'); return; }
      if ((el = e.target.closest('[data-sbv-pick]'))) { state = { p: +el.dataset.sbvPick }; renderShop(); return; }
      if ((el = e.target.closest('[data-sbv-add]'))) { add(el); return; }
      if ((el = e.target.closest('.sbv-s a'))) track('gs_product_click', { source: 'video', video: cur });
    });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-sbv-var]')) { state.v = +e.target.value; renderShop(); } });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight' && cur < tiles.length) open(cur + 1);
      if (e.key === 'ArrowLeft' && cur > 1) open(cur - 1);
    });
  }
  function boot() { document.querySelectorAll('[data-sbv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-sbv]'); if (r) init(r); });
})();

  } catch(e) { console.error(e); }
})();
})();
